<script>
    import Multiselect from 'vue-multiselect';

    export default
    {
        extends: Multiselect,
        props:
        {
            multiple: {
                type: Boolean,
                default: true,
            },
            closeOnSelect: {
                type: Boolean,
                default: false,
            },
            trackBy: {
                type: String,
                default: 'id'
            },
            selectLabel: {
                default: 'Wybierz'
            },
            selectGroupLabel: {
                default: 'Wybierz grupę'
            },
            selectedLabel: {
                default: 'Zaznaczone',
            },
            deselectLabel: {
                default: 'Usuń',
            },
            deselectGroupLabel: {
                default: 'Usuń zaznaczone'
            },
            limitText: {
                default: (count) => {return ` + ${count}`;}
            }
        },
    }
</script>

<style>
span.multiselect__option--selected {
  pointer-events: none !important;
}
.multiselect{
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// Multiselect.vue?4e8645a9